import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.admin');
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'wiz-component-nav-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.admin/view.scss */
/* src/app/component.nav.admin/view.scss: no such file or directory */`],
})
export class ComponentNavAdminComponent implements OnInit {
    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,@Inject( ChangeDetectorRef)         private cdr: ChangeDetectorRef) { }

    public org_menus = [
        { label: '정보', path: 'info', icon: 'Info' },
        { label: '이슈', path: 'issue', icon: 'Ticket' },
        { label: '문서함', path: 'document', icon: 'FolderOpen' }
    ]
    public showOrgSubmenu = true;
    // public selectedOrganization = "주식회사 시즌";
    public selectedOrganization: any;

    public adminMenu = [
        // Management
        { id: 'user-mgmt', label: '사용자 관리', icon: 'Users', mainPath: '/admin/users', path: '/admin/users', category: 'management' },
        { id: 'org-mgmt', label: '기관 관리', icon: 'Building2', mainPath: '/admin/institutes', path: '/admin/institutes', category: 'management' },
        { id: 'ticket-mgmt', label: '이슈 관리', icon: 'TicketCheck', mainPath: '/admin/issues', path: '/admin/issues', category: 'management' },
        { id: 'port-mgmt', label: '포트 관리', icon: 'Network', mainPath: '/admin/ports', path: '/admin/ports', category: 'management' },
        { id: 'notice-mgmt', label: '공지사항 관리', icon: 'Megaphone', mainPath: '/admin/notices/alert', path: ['/admin/notices/alert', '/admin/notices/use'], category: 'management' },

        // Settings
        // { id: 'automation', label: '자동화 작업', icon: 'Zap', mainPath: '/admin/system/workflow', path: '/admin/system/workflow', category: 'settings' },
        // { id: 'weather-map', label: '웨더맵 설정', icon: 'Cloud', mainPath: '/admin/system/weathermap', path: '/admin/system/weathermap', category: 'settings' },
        // { id: 'availability', label: '가용률 설정', icon: 'Activity', mainPath: '/admin/system/availability', path: '/admin/system/availability', category: 'settings' },

        // Others
        // { id: 'manual-mgmt', label: '매뉴얼 관리', icon: 'BookOpen', mainPath: '/admin/system/manuals', path: '/admin/system/manuals', category: 'others' }
    ];

    public categories = {
        management: { label: '관리', colorClass: 'text-gray-700' },
        // settings: { label: '설정', colorClass: 'text-gray-700' },
        // others: { label: '기타', colorClass: 'text-gray-700' }
    };
    public categoryKeys = Object.keys(this.categories);
    public collapsedCategories: any = {};

    public session: any;
    public insID: any;
    public mode: any;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("admin", "/");
        this.session = this.service.auth.session;
        await this.service.render();

        console.log(this.session.role)

        // ✅ URL 변경 반응
        this.navSub = this.router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
            .subscribe(() => {
                // 비동기지만 기다릴 필요는 없음
                this.updateFromUrl();
            });

        // 초기 실행
        await this.updateFromUrl();
        await this.service.render();
    }

    public ngOnDestroy() {
        this.navSub?.unsubscribe();
    }

    private async updateFromUrl() {
        const url = this.router.url;

        if (url.includes('/admin/institutes/')) {
            const segments = url.split('/').filter(Boolean);
            const idx = segments.indexOf('institutes');
            const insID = segments[idx + 1] || null;
            const mode = segments[idx + 2] || null;

            const changed = this.insID !== insID || this.mode !== mode;
            this.insID = insID;
            this.mode = mode;
            if (changed) {
                // 🔥 서버에 insID로 기관 정보 요청
                const { code, data } = await wiz.call("load", { insID: this.insID });
                if (code === 200 && data) {
                    this.selectedOrganization = data.name;
                    this.showOrgSubmenu = true;
                    await this.service.render();
                } else {
                    this.selectedOrganization = null;
                    this.showOrgSubmenu = false;
                    await this.service.alert.error("기관 정보를 불러올 수 없습니다.");
                }
                this.cdr.detectChanges();
            }
        } else {
            this.insID = null;
            this.mode = null;
            this.selectedOrganization = null;
            this.showOrgSubmenu = false;
            await this.service.render();
        }
        await this.service.render();
    }

    public toggleCategory(category: string) {
        this.collapsedCategories = {
            ...this.collapsedCategories,
            [category]: !this.collapsedCategories[category]
        };
    }

    public getAdminItemsBy(categoryKey: string) {
        return this.adminMenu.filter(i => i.category === categoryKey);
    }

    // public isActive(link: string) {
    //     return location.pathname.indexOf(link) === 0
    // }
    public isActive(link: string | string[]) {
        const path = location.pathname;
        const links = Array.isArray(link) ? link : [link];
        return links.some(l => path.startsWith(l));
    }

    // lucide 이름 → Tabler 아이콘 클래스 매핑
    public getIconClass(iconName: string) {
        const map = {
            LayoutDashboard: 'fa-solid fa-gauge',
            Building2: 'fa-solid fa-building',
            Bell: 'fa-solid fa-bell',
            FileText: 'fa-solid fa-file-lines',
            User: 'fa-solid fa-user',
            Users: 'fa-solid fa-users',
            TicketCheck: 'fa-solid fa-ticket',
            Network: 'fa-solid fa-network-wired',
            Megaphone: 'fa-solid fa-bullhorn',
            Zap: 'fa-solid fa-bolt',
            Cloud: 'fa-solid fa-cloud',
            Activity: 'fa-solid fa-chart-line',
            BookOpen: 'fa-solid fa-book-open',
            Info: 'fa-solid fa-circle-info',
            Ticket: 'fa-solid fa-ticket',
            FolderOpen: 'fa-solid fa-folder-open',
            Settings: 'fa-solid fa-gear',
            LogOut: 'fa-solid fa-right-from-bracket',
            ChevronDown: 'fa-solid fa-chevron-down',
            Circle: 'fa-solid fa-circle'
        };
        return map[iconName] || 'fa-solid fa-circle';
    }
}

export default ComponentNavAdminComponent;